module.exports = {"first":"Eerste","previous":"Vorige","next":"Volgende","last":"Laatste","ellipsis":"…","items-per-page":"items per pagina"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/nl/pagination.json
// module id = YsHr
// module chunks = 1